/*
 * ****************************************************************************
 * Copyright (C) 2018-2018, All rights reserved.
 * Project: chessmate
 * Created On: March 23rd, 2018
 * Last Modified: March 23rd, 2018
 * ****************************************************************************
 */

import * as React from 'react';
import constants from 'app/constants';

/** PageTitleProps - Properties */
export interface PageTitleProps {
  children?: string;
}

/** PageTitle */
export class PageTitle extends React.Component<PageTitleProps> {
  constructor(props: PageTitleProps, ctx: any) {
    super(props, ctx);
  }
  render() {
    // ROK - this is a pseudo-element who's only purpose is to set the title
    window.document.title = `${this.props.children} - ${constants.title}`;
    return null;
  }
}

export default PageTitle;


// WEBPACK FOOTER //
// ./src/components/pageTitle.tsx